import Vue from "vue";

export const JustDigits = () => {
    Vue.directive("digitsonly", {
        bind: (el, binding) => {
            const handler = e => {
                if (el == e.target) {
                    if (/^\d+$/.test(el.value)) {
                    } else {
                        el.value = el.value.replace(/\D+/gi, "");
                    }
                    if (el.value && binding.value && binding.value.min && binding.value.max) {
                        if (el.value < binding.value.min) {
                            el.value = binding.value.min;
                        }
                        if (el.value > binding.value.max) {
                            el.value = binding.value.max;
                        }
                    }
                }
            };
            el.digitsonly = handler;
            document.addEventListener("input", handler);
        },
        unbind(el, binding) {
            // Remove Event Listeners
            document.removeEventListener("input", el.digitsonly);
            el.vueTest = null;
        }
    });
};



// WEBPACK FOOTER //
// ./src/utils/JustDigit.js